export default {
    apiKey: "AIzaSyDWQKq-8tfbhX8es63cDB7BlyAKC6oZc64",
    authDomain: "communitymap42.firebaseapp.com",
    databaseURL: "https://communitymap42.firebaseio.com",
    projectId: "communitymap42",
    storageBucket: "communitymap42.appspot.com",
    messagingSenderId: "84150682459",
    appId: "1:84150682459:web:a1c76cdaf9ac8a1a5c907e",
    measurementId: "G-THYPGCDTVM"
};
//# sourceMappingURL=.fb-conf-prod.js.map